import React from 'react';
import { Field } from 'react-final-form';

//Components
import { campotexto } from '../campos/campos';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

class FormValidarCodigo extends React.Component {
    
    render(){        
        return (
            <>
                <Field type='type' name='codigo' label={trad(this.props.trads,'Código',this.props.lingua)} component={campotexto} />
            </>
        )
    }
}

export default FormValidarCodigo;